import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log full stack for diagnostics (visible in browser console)
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;

      const msg = this.state.error?.message || String(this.state.error || 'Error desconocido');
      const stack = this.state.errorInfo?.componentStack || this.state.error?.stack || '';

      return (
        <div className="p-8 text-center" data-testid="page-error-boundary">
          <div className="max-w-xl mx-auto bg-white border border-red-200 rounded-xl p-8 shadow-sm text-left">
            <p className="text-lg font-semibold text-slate-800 text-center">Ocurrió un error al mostrar esta sección</p>
            <p className="text-sm text-slate-500 mt-2 text-center">
              La página no se cerró: podés recargar para volver a intentar. Si el error persiste, sacá una captura de este detalle.
            </p>
            <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg" data-testid="page-error-message">
              <p className="text-xs font-semibold text-red-700 uppercase tracking-wide mb-1">Detalle del error</p>
              <p className="text-sm font-mono text-red-800 break-words">{msg}</p>
              {stack && (
                <pre className="mt-2 text-[10px] text-red-700/80 whitespace-pre-wrap max-h-40 overflow-auto">{stack}</pre>
              )}
            </div>
            <div className="flex gap-2 justify-center mt-5">
              <button
                onClick={() => this.setState({ hasError: false, error: null, errorInfo: null })}
                className="px-4 py-2 bg-slate-100 hover:bg-slate-200 rounded-lg text-sm font-medium text-slate-700 transition-colors"
                data-testid="page-error-retry-btn"
              >
                Reintentar
              </button>
              <button
                onClick={() => window.location.reload()}
                className="px-5 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-sm font-medium transition-colors"
                data-testid="page-error-reload-btn"
              >
                Recargar página
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
